<template>
  <div style="height: 100%;">
    <ValidationObserver ref="observer" v-if="!loading">
      <v-row class="linha mt-2 mb-0 mx-0">
        <v-col cols="auto" sm="3" class="pb-0 px-0">
          <div class="mb-2">
            Situação Atual da Unimed
          </div>
          <div class="mb-2">
            <span style="width: 50px; display: inline-block;">{{ !dadosCadastrais.ativa ? 'Inativa' : 'Ativa' }}</span>
            <switch-cadu
              style="display: inline-block;"
              :disabled="editarSwitch"
              @input="changeSwitch"
              :value="dadosCadastrais.ativa"
            />
          </div>
        </v-col>

        <v-col
          v-if="!dadosCadastrais.ativa"
          cols="12"
          sm="3"
          md="2"
          :class="$vuetify.breakpoint.xs ? 'pa-0 ma-0' : 'pb-0 pl-2 pr-1'"
        >
          <datepicker-cadu
            inputTitle="Data de Inativação"
            :validateProviderRules="dadosCadastrais.ativa ? '' : 'required|dateValidatorForPass'"
            :inputValue="dadosCadastrais.dataInativacao"
            :disabled="dadosCadastrais.ativa ? '' : editardataInativacao"
            @value="(value) => (dadosCadastrais.dataInativacao = value)"
            ref="picker"
            :maxDate="today"
            typeCalendar="date"
            width="300"
          ></datepicker-cadu>
        </v-col>

        <v-col
          v-if="!dadosCadastrais.ativa"
          cols="12"
          sm="4"
          :class="$vuetify.breakpoint.xs ? 'pa-0 ma-0' : 'pb-0 pr-0'"
        >
          <ValidationProvider
            ref="motivo"
            mode="eager"
            :rules="!dadosCadastrais.ativa ? 'required|max:300' : ''"
            v-slot:default="{ errors }"
          >
            <input-cadu
              :errorMessage="errors[0]"
              title="Motivo"
              :max="'300'"
              :disabled="dadosCadastrais.ativa ? '' : editarMotivo"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              v-model="dadosCadastrais.motivoInativacao"
            />
          </ValidationProvider>
        </v-col>
      </v-row>

      <v-row class="mt-0 mb-0">
        <v-col cols="12" sm="3" class="pb-0">
          <ValidationProvider mode="eager" rules="max:300">
            <input-cadu
              title="Código"
              :disabled="true"
              :value="dadosCadastrais.cdUnimed"
              :colorText="$vuetify.theme.themes.light.fontColor1"
            />
          </ValidationProvider>
        </v-col>

        <v-col cols="12" sm="7" class="pb-0">
          <ValidationProvider mode="eager" rules="required|max:150" v-slot:default="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="Nome Fantasia"
              name="nomeFantasia"
              :disabled="editarNomeFantasia"
              v-model="dadosCadastrais.nomeFantasia"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              :max="'150'"
            />
          </ValidationProvider>
        </v-col>
      </v-row>

      <v-row class="mt-0 mb-0">
        <v-col cols="12" sm="8" md="7" class="pb-0">
          <ValidationProvider mode="eager" rules="required|max:150" v-slot:default="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="Razão Social"
              :disabled="editarRazaoSocial"
              v-model="dadosCadastrais.razaoSocial"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              :max="'150'"
            />
          </ValidationProvider>
        </v-col>

        <v-col cols="12" sm="3" md="4" class="pb-0">
          <datepicker-cadu
            inputTitle="Data da Fundação"
            :validateProviderRules="'required|dateValidatorForPass'"
            :inputValue="dadosCadastrais.dataFundacao"
            :disabled="editardataFundacao"
            @value="(value) => (dadosCadastrais.dataFundacao = value)"
            :maxDate="today"
            ref="picker"
            typeCalendar="date"
            width="300"
          ></datepicker-cadu>
        </v-col>
      </v-row>

      <v-row class="mt-0 mb-0">
        <v-col cols="12" sm="3" class="pb-0">
          <ValidationProvider mode="lazy" rules="required|cnpjValidate" v-slot:default="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              :disabled="editarCnpj"
              title="CNPJ"
              :mask="cnpjMask"
              v-model="dadosCadastrais.cnpj"
              :colorText="$vuetify.theme.themes.light.fontColor1"
            />
          </ValidationProvider>
        </v-col>

        <v-col cols="12" sm="4" lg="2" class="pb-0">
          <ValidationProvider mode="eager" rules="min:7|max:15" v-slot:default="{ errors }">
            <input-cadu
              style="white-space: nowrap;"
              :errorMessage="errors[0]"
              :disabled="editarInscEsta"
              title="Inscrição Estadual"
              placeholder="ISENTO"
              colorPlaceholder="#54585e"
              v-model="dadosCadastrais.inscricaoEstadual"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              :max="'20'"
            />
          </ValidationProvider>
        </v-col>

        <v-col cols="12" sm="4" lg="3" class="pb-0">
          <ValidationProvider mode="eager" rules="min:4|max:20" v-slot:default="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              :disabled="editarInscMuni"
              title="Inscrição Municipal"
              placeholder="ISENTO"
              colorPlaceholder="#54585e"
              v-model="dadosCadastrais.inscricaoMunicipal"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              :max="'20'"
            />
          </ValidationProvider>
        </v-col>

        <v-col cols="12" sm="4" lg="4" class="pb-0">
          <ValidationProvider mode="eager" rules="required" v-slot="{ errors }">
            <autocomplete-cadu
              :errorMessage="errors[0]"
              title="Porte"
              :disabled="true"
              v-model="dadosCadastrais.porte.nome"
              :items="portes.map((el) => el.nome)"
              :colorText="$vuetify.theme.themes.light.fontColor1"
            />
          </ValidationProvider>
        </v-col>

        <v-col cols="12" sm="4" class="pb-0">
          <div class="fontColor1--text pb-1" style="font-size: 1.12em;">
            Participação Societária
          </div>
          <div
            class="checkbox-group"
            :style="
              opcaoEditar === 'false' || role !== 'admin_brasil'
                ? {
                    'background-color': '#DEE2E6 !important',
                    opacity: '0.7',
                    cursor: 'not-allowed'
                  }
                : {}
            "
          >
            <div v-for="(participacao, index) in participacaoChecks" :key="index">
              <checkbox-cadu
                v-model="participacaoArray"
                :value="participacao.id"
                style="width: 220px;"
                :disable="opcaoEditar === 'false' || role != 'admin_brasil'"
              >
                <div slot="text" style="color: #54585e;">
                  {{ participacao.nome }}
                </div>
              </checkbox-cadu>
            </div>
          </div>
        </v-col>

        <!-- <v-col cols="12" sm="4" class="pb-0">
          <ValidationProvider mode="eager" rules="max:80|urlValidate" v-slot="{ errors }">
            <input-cadu
              :errorMessage="errors[0]"
              title="Website"
              :disabled="editarSite"
              v-model="dadosCadastrais.website"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              :max="'60'"
              :onlylowerCase="true"
              emailMask
            />
          </ValidationProvider>
        </v-col> -->
      </v-row>

      <v-row class="mt-0 mb-0" />

      <v-row class="mt-0 mb-0">
        <v-col cols="12" sm="10" class="pb-0">
          <ValidationProvider rules="max:500" v-slot="{ errors }">
            <textarea-cadu
              :errorMessage="errors[0] ? errors[0] : ''"
              :disabled="editarSituacaoUnimed"
              title="Observações"
              v-model="dadosCadastrais.observacao"
              :colorText="$vuetify.theme.themes.light.fontColor1"
              :max="'500'"
            />
          </ValidationProvider>
        </v-col>
      </v-row>
    </ValidationObserver>

    <component-loading :value="loading" />

    <ErrorModal v-model="error" :errObj="errObj" />

    <modal-cancelar v-model="showModalCancelar" @cancelar-edicao="cancelarEdicao()" />
  </div>
</template>

<script>
import moment from 'moment'
import jwtDecode from 'jwt-decode'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { cloneDeep } from 'lodash'

import ValidationMixin from '@/Mixins/ValidationMixin'

import { EventBus } from '@/services/EventBus/EventBus'
import Unimed from '@/services/Unimed'
import Portes from '@/services/Dominios/Porte'
import DadosCadastrais from '@/services/MinhaUnimed/DadosCadastrais/ViewDadosCadastrais/DadosCadastrais'

import ErrorModal from '../../../Shared/ErrorModal/ErrorModal'

export default {
  mixins: [ValidationMixin],
  components: {
    ValidationProvider,
    ValidationObserver,
    ErrorModal
  },
  data() {
    return {
      dadosCadastrais: { partSocietaria: [], porte: { nome: '' } },
      cloneDadosCadastrais: {}, // Dados cadastrais iniciais (sem alterações)
      participacaoChecks: [],
      partSocietaria: [],
      participacaoArray: [],
      all: false,
      idDados: 0,
      opcaoEditar: localStorage.getItem('optionEdit'),
      loading: false,
      error: false,
      menuOpen: false,
      menuOpenInativacao: false,
      today: moment().format('DD/MM/YYYY'),
      dataFundacaoValue: '',
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      showModalCancelar: false,
      portes: [],
      dataFundacaoFormatada: '',
      dataFundadacaoBool: true,
      dataInativacaoFormatada: '',
      dataInativacaoBool: true,
      cnpjMask: {
        mask: 'XX.XXX.XXX/XXXX-##',
        tokens: {
          'X': { pattern: /[A-Za-z0-9]/, transform: v => v.toUpperCase() },
          '#': { pattern: /\d/ }
        }
      }
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)

    this.role = decoded.role
    this.id = decoded.idUsuario
    this.loading = true

    await this.getPortes()

    await this.getAllDadosCadastrias()

    this.loading = false
    this.$emit('complete')
    this.cloneDadosCadastrais = cloneDeep(this.dadosCadastrais)

    this.cloneDadosCadastrais.participacoesSocietarias.forEach((el) => {
      delete el.nome // Removendo nome de participações Societarias (não utilizado)
    })
  },
  beforeDestroy() {
    localStorage.setItem('situacaoUnimed', this.dadosCadastrais.ativa)
  },
  methods: {
    dadosCadastraisdataInativacao() {
      if (this.dataInativacaoBool && this.dadosCadastrais.dataInativacao) {
        this.dataFundadacaoBool = false
        this.dataInativacaoFormatada = moment(this.dadosCadastrais.dataInativacao, 'DD/MM/YYYY').format('YYYY-DD-MM')
      }
    },
    dadosCadastraisDataFundacao() {
      if (this.dataFundadacaoBool) {
        this.dataFundadacaoBool = false
        this.dataFundacaoFormatada = moment(this.dadosCadastrais.dataFundacao, 'DD/MM/YYYY').format('YYYY-DD-MM')
      }
    },
    changeSwitch(input) {
      localStorage.setItem('situacaoUnimed', input)
      this.dadosCadastrais.dataInativacao = ''
      this.dadosCadastrais.motivoInativacao = ''
      if (!this.dadosCadastrais.ativa) {
        this.$refs.motivo.reset()
        this.$refs.picker.reset()
      }
      this.dadosCadastrais.ativa = input
    },
    selectAll() {
      let participacaoArray = []
      this.participacaoArray = participacaoArray
    },
    async getPortes() {
      const portes = new Portes(this.tokenBearer, this.$appConfig.config.API)

      await portes
        .getPortes()
        .then((responseGet) => {
          this.portes = responseGet.data
        })
        .catch((err) => {
          console.error(err)

          this.loading = false
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })
    },
    async getAllDadosCadastrias() {
      this.loading = true

      const dadosCadastrais = new DadosCadastrais(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)
      const unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)

      await dadosCadastrais
        .getDadosCadastrais()
        .then((res) => (this.dadosCadastrais = res.data))
        .catch((err) => {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })

      await unimed
        .getParticipacoes()
        .then((res) => (this.participacaoChecks = res.data))
        .catch((err) => {
          this.error = true
          this.errObj.status = err.response.status
          this.errObj.error = err.response.data.message
        })

      this.participacaoArray = []

      this.dadosCadastraisDataFundacao()
      this.dadosCadastraisdataInativacao()

      this.dadosCadastrais.participacoesSocietarias.forEach((el) => {
        this.participacaoArray.push(el.id)
      })
    },
    async validarMudanca() {
      let arr = []

      this.participacaoArray.forEach((el) => {
        arr.push({ id: el })
      })

      this.dadosCadastrais.participacoesSocietarias = arr
      this.dadosCadastrais.cnpj = this.dadosCadastrais.cnpj.replace(/[^A-Za-z0-9]/g, '').toUpperCase()

      if (this.getDiffInObjects(this.cloneDadosCadastrais, this.dadosCadastrais)) {
        this.showModalCancelar = true
      }
    },
    async cancelarEdicao() {
      this.showModalCancelar = false
      this.loading = true
      this.dadosCadastrais = { ...this.cloneDadosCadastrais }

      await this.getPortes()
        .then(() => EventBus.$emit('cancelarDados'))
        .catch((err) => console.error(err))
        .finally(() => (this.loading = false))
    },
    async validateForm() {
      this.opcaoEditar = JSON.parse(localStorage.getItem('optionEdit'))

      await this.$nextTick()

      if (!this.$refs.observer) {
        this.$emit('complete')
        return false
      }

      const res = await this.$refs.observer.validate()

      if (this.opcaoEditar && res) {
        this.dadosCadastrais.cnpj = this.dadosCadastrais.cnpj.replace(/[^A-Za-z0-9]/g, '').toUpperCase()

        this.dadosCadastrais.dataInativacao === ''
          ? (this.dadosCadastrais.dataInativacao = null)
          : (this.dadosCadastrais.dataInativacao = this.dadosCadastrais.dataInativacao)

        this.dadosCadastrais.dataInativacao = this.dadosCadastrais.ativa ? '' : this.dadosCadastrais.dataInativacao
        this.cloneDadosCadastrais.dataInativacao = this.cloneDadosCadastrais.ativa
          ? ''
          : this.cloneDadosCadastrais.dataInativacao

        this.dadosCadastrais.motivoInativacao = this.dadosCadastrais.ativa ? '' : this.dadosCadastrais.motivoInativacao
        this.cloneDadosCadastrais.motivoInativacao = this.cloneDadosCadastrais.ativa
          ? ''
          : this.cloneDadosCadastrais.motivoInativacao

        const arr = this.participacaoArray.map((el) => {
          return { id: el }
        })

        this.dadosCadastrais.participacoesSocietarias = arr

        if (!this.getDiffInObjects(this.cloneDadosCadastrais, this.dadosCadastrais)) {
          this.$emit('complete')
          return true
        }

        const dadosCadastrais = new DadosCadastrais(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

        return await dadosCadastrais
          .putDadosCadastrais(this.dadosCadastrais)
          .then(() => {
            this.$emit('complete')

            return true
          })
          .catch((err) => {
            this.error = true
            this.errObj.status = err.response.status
            this.errObj.error = err.response.data.message

            this.$emit('complete')
            return false
          })
      } else if (!this.opcaoEditar) {
        this.$emit('complete')
        return true
      } else {
        this.$emit('complete')
        return false
      }
    }
  },
  watch: {
    dataFundacao() {
      this.dataFundacao = this.dataFundacao
    }
  },
  computed: {
    centralizadoTablet() {
      return this.$vuetify.breakpoint.sm
    },
    editarSwitch() {
      if (this.opcaoEditar === 'false') {
        return true
      }
      let list = ['admin_brasil']
      return !list.includes(this.role)
    },
    editarNomeFantasia() {
      if (this.opcaoEditar === 'false') {
        return true
      }
      let list = ['admin_brasil']
      return !list.includes(this.role)
    },
    editarRazaoSocial() {
      if (this.opcaoEditar === 'false') {
        return true
      }
      let list = ['admin_brasil']
      return !list.includes(this.role)
    },
    editardataFundacao() {
      if (this.opcaoEditar === 'false') {
        return true
      }
      let list = ['admin_brasil']
      return !list.includes(this.role)
    },
    editarCnpj() {
      if (this.opcaoEditar === 'false') {
        return true
      }
      let list = ['admin_brasil']
      return !list.includes(this.role)
    },
    editarInscEsta() {
      if (this.opcaoEditar === 'false') {
        return true
      }
      let list = ['admin_brasil']
      return !list.includes(this.role)
    },
    editarInscMuni() {
      if (this.opcaoEditar === 'false') {
        return true
      }
      let list = ['admin_brasil']
      return !list.includes(this.role)
    },
    editarSite() {
      if (this.opcaoEditar === 'false') {
        return true
      }
      let list = ['admin_brasil', 'dirigente', 'admin']
      return !list.includes(this.role)
    },
    editarEmail() {
      if (this.opcaoEditar === 'false') {
        return true
      }
      let list = ['admin_brasil', 'dirigente', 'admin']
      return !list.includes(this.role)
    },
    editarParticipacaoSocietaria() {
      if (this.opcaoEditar === 'false') {
        return true
      }
      let list = ['admin_brasil']
      return !list.includes(this.role)
    },
    editarSituacaoUnimed() {
      if (this.opcaoEditar === 'false') {
        return true
      }
      let list = ['admin_brasil']
      return !list.includes(this.role)
    },
    editardataInativacao() {
      if (this.opcaoEditar === 'false') {
        return true
      }
      let list = ['admin_brasil']
      return !list.includes(this.role)
    },
    editarMotivo() {
      if (this.opcaoEditar === 'false') {
        return true
      }
      let list = ['admin_brasil']
      return !list.includes(this.role)
    },
    editarObs() {
      if (this.opcaoEditar === 'false') {
        return true
      }
      let list = ['admin_brasil']
      return !list.includes(this.role)
    }
  }
}
</script>

<style lang="sass" scoped>
.linha
  border-bottom: 1px solid #DEE2E6

.checkbox-group
  height: 112px
  width: 100%
  overflow: auto
  padding: 5px 0px 5px 15px
  border: #9E9E9E 1px solid
  border-radius: 5px
</style>
